module.exports = __webpack_public_path__ + "img/2.1eb87215.jpg";